export const state = {
  isCollapsed: false,
  calls: [],
  broadcasts: [],
  isMuted: false,
  voipState: {},
  maxCall: 1,
  isTwoWayActive: false,
  isBroadcastActive: false,
}

export const getters = {
  vehicleIdsCallActive: (state) => {
    return state.calls.map((call) => call.vehicleId)
  },
  sumCallsActive: (state) => {
    return state.calls.length
  },
  vehicleIdsBroadcastActive: (state) => {
    return state.broadcasts.map((broadcast) => broadcast.vehicleId)
  },
  sumBroadcastActive: (state) => {
    return state.broadcasts.length
  },
}

export const actions = {
  startNewCall(
    { commit },
    {
      dataNewCall: {
        vehicleId,
        licensePlate,
        driver,
        imei,
        deviceType,
        entryPoint,
        isDebugBroadcast,
      },
      isAutoReconnect = false,
      isBroadcast = false,
    }
  ) {
    commit('addCalls', {
      vehicleId,
      licensePlate,
      driver,
      imei,
      deviceType,
      entryPoint,
      isDebugBroadcast,
    })
    if (isAutoReconnect) return
    let callsActive
    if (!window.localStorage.getItem('voipActive')) {
      callsActive = []
    } else {
      callsActive = JSON.parse(window.localStorage.getItem('voipActive'))
    }

    const mergedCalls = [
      ...callsActive,
      { vehicleId, licensePlate, driver: driver ?? null, imei, deviceType },
    ]
    if (!isBroadcast) {
      window.localStorage.setItem('voipActive', JSON.stringify(mergedCalls))
    }
  },

  addBroadcastVehicle({ commit }, { dataNewBroadcast: { vehicleId, licensePlate, driver, imei } }) {
    commit('addBroadcast', { vehicleId, licensePlate, driver, imei })
  },

  endCall({ commit }, { vehicleId }) {
    commit('removeCalls', vehicleId)
    commit('deleteVoipState', vehicleId)
    const callsActive = JSON.parse(window.localStorage.getItem('voipActive'))
    window.localStorage.setItem(
      'voipActive',
      JSON.stringify(callsActive.filter((call) => call.vehicleId !== vehicleId))
    )
  },

  endCallAll({ commit }) {
    commit('resetVoipState')
    commit('removeAllCalls')
    window.localStorage.setItem('voipActive', JSON.stringify([]))
  },
}

export const mutations = {
  setIsCollapsed(state, payload) {
    state.isCollapsed = payload
  },
  setIsTwoWayActive(state, payload) {
    state.isTwoWayActive = payload
  },
  /**
   *
   * @param {*}  vehicleId
   * @param {*}  licensePlate
   * @param {*}  driver
   * @param {*}  imei
   * @param {*}  deviceType
   * @param {*}  entryPoint | 'modalDetailVehicle' | 'floatingMap' | 'alertCenter' | 'detailNotification' | 'controlTower' | 'mediaPlayerStreaming' | 'modalAlertMedia'
   */
  addCalls(
    state,
    { vehicleId, licensePlate, driver, imei, deviceType, entryPoint, isDebugBroadcast }
  ) {
    const tempCalls = [
      ...state.calls,
      { vehicleId, licensePlate, driver, imei, deviceType, entryPoint, isDebugBroadcast },
    ]
    state.calls = tempCalls
  },
  removeCalls(state, vehicleId) {
    const tempCalls = state.calls.filter((call) => vehicleId !== call.vehicleId)
    state.calls = tempCalls
  },
  removeAllCalls(state) {
    state.calls = []
  },
  toggleMuted(state) {
    state.isMuted = !state.isMuted
  },
  setIsMuted(state, payload) {
    state.isMuted = payload
  },
  setVoipState(state, { vehicleId, values }) {
    const tempState = Object.assign({}, state.voipState)
    tempState[vehicleId] = values
    state.voipState = tempState
  },

  deleteVoipState(state, vehicleId) {
    const tempState = Object.assign({}, state.voipState)
    delete tempState[vehicleId]
    state.voipState = tempState
  },

  resetVoipState(state) {
    state.voipState = {}
  },

  setMaxCall(state, payload) {
    state.maxCall = payload
  },

  setIsBroadcastActive(state, payload) {
    state.isBroadcastActive = payload
  },

  addBroadcast(state, { vehicleId, licensePlate, driver, imei }) {
    const tempBroadcasts = [...state.broadcasts, { vehicleId, licensePlate, driver, imei }]
    state.broadcasts = tempBroadcasts
  },

  removeBroadcast(state, vehicleId) {
    const tempBroadcasts = state.broadcasts.filter((broadcast) => vehicleId !== broadcast.vehicleId)
    state.broadcasts = tempBroadcasts
  },
}
